// Note: client only functions
import { addDays } from 'date-fns';
import { cookies } from '@/services/jucyCookies';

export const PREFERRED_SITE_COOKIE_NAME = 'preferred-site';
const DAYS_UNTIL_EXPIRY = 30;
export type SiteSlugType = 'au' | 'nz';

export function setPreferredSiteCode(siteSlug: SiteSlugType): void {
    const expires = addDays(new Date(), DAYS_UNTIL_EXPIRY);
    cookies.set(PREFERRED_SITE_COOKIE_NAME, siteSlug, { expires });
}

export function getPreferredSiteCode(): 'au' | 'nz' | undefined {
    const siteSlug: SiteSlugType = cookies.get(PREFERRED_SITE_COOKIE_NAME);
    if (siteSlug === 'au' || siteSlug === 'nz') {
        return siteSlug;
    }
    return undefined;
}

export function isFirstTimeVisit(): boolean {
    const siteSlug = cookies.get(PREFERRED_SITE_COOKIE_NAME);
    return !siteSlug;
}
